<template>
  <nd-radio-group v-model="value" class="filter-item-radio" :options="radioOptions" :show-mask="true" />
</template>

<script setup lang="ts">
import NdRadioGroup from '@/components/form/nd-radio-group.vue'

import type { SfilterFilterTag } from '@/types/api'

const value = defineModel<number>()

const props = withDefaults(
  defineProps<{
    options?: SfilterFilterTag
  }>(),
  {
    options: () => ({
      title: '',
      tags: [],
    }),
  }
)

const radioOptions = computed(() => props.options.tags?.map(t => ({ id: t.id, name: t.name })) ?? [])
</script>

<style lang="scss" scoped>
.filter-item-radio {
}
</style>
